<div #detailsContainer style="overflow: auto; height: 100%">
  <div *ngIf="autoRedactionJob.runStatus === RunStatus.created; else queued">
    <div *ngIf="!autoRedactionJob.autoRedactionRules || autoRedactionJob.autoRedactionRules.length === 0;else rules" style="font-size: 13px;">
      [No rules entered]
    </div>
    <ng-template #rules>

      <table mat-table [dataSource]="autoRedactionRulesDataSource" class="mat-elevation-z8">

        <ng-container matColumnDef="ruleTitle">
          <th mat-header-cell *matHeaderCellDef>Title</th>
          <td mat-cell *matCellDef="let element">{{element.ruleTitle}}</td>
        </ng-container>

        <ng-container matColumnDef="redactionLabel">
          <th mat-header-cell *matHeaderCellDef>Label</th>
          <td mat-cell *matCellDef="let element">{{element.redactionLabel}}</td>
        </ng-container>

        <ng-container matColumnDef="rulePattern">
          <th mat-header-cell *matHeaderCellDef>Search Text</th>
          <td mat-cell *matCellDef="let element">{{element.rulePattern}}</td>
        </ng-container>

        <ng-container matColumnDef="presetType">
          <th mat-header-cell *matHeaderCellDef>Preset Type</th>
          <td mat-cell *matCellDef="let element">{{element.presetType}}</td>
        </ng-container>

        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>
            <mat-icon>delete</mat-icon>
          </th>
          <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation(); deleteOrUndoRule(element.id);">
            <mat-icon>delete</mat-icon>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="ruleColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: ruleColumns;" (click)="showAddRuleDialog(row)"></tr>

      </table>

    </ng-template>
  </div>
  <ng-template #queued>
    <div *ngIf="autoRedactionJob.runStatus === RunStatus.running; else show_results" style="font-size: 13px;">
      <strong>
        Warning! Auto Redactions should always be verified for accuracy prior to production.
        <br />
        See documentation for more information.
      </strong>
    </div>
    <ng-template #show_results>
      <!-- Choose whichever height is greater: parent or graph. This means the the graph will stretch to fill available space if shorter than parent, but not shrink to an unreadable size if larger (graphHeight is effectively a min height here). -->
      <div *ngIf="isGraphView; else show_data" [style.height.px]="detailsContainer.offsetHeight > graphHeightByCount ? detailsContainer.offsetHeight : graphHeightByCount">
        <ngx-charts-bar-horizontal-2d [groupPadding]="computePadding(detailsContainer.offsetHeight)" [results]="chartGroups" [xAxis]="true" [showXAxisLabel]="true" [xAxisLabel]="'Hits'" [yAxis]="true" [showYAxisLabel]="true" [yAxisLabel]="'Rule'" [legend]="true"
                                      (select)="browseRule($event)"></ngx-charts-bar-horizontal-2d>
      </div>

      <ng-template #show_data>

        <table mat-table [dataSource]="autoRedactionRulesDataSource" class="mat-elevation-z8" style="overflow: auto; width: 100%">
          <ng-container matColumnDef="ruleTitle">
            <th mat-header-cell *matHeaderCellDef>Rule</th>
            <td mat-cell *matCellDef="let element">
              <a [routerLink]="['/review/browse']" [queryParams]="{ AutoRedactionRuleIds: [element.id] }">
                {{element.ruleTitle}}
              </a>
            </td>
          </ng-container>
          <ng-container matColumnDef="docCount">
            <th mat-header-cell *matHeaderCellDef>Documents Redacted</th>
            <td mat-cell *matCellDef="let element">{{element.docCount}}</td>
          </ng-container>
          <ng-container matColumnDef="redactionCount">
            <th mat-header-cell *matHeaderCellDef>Total Redactions</th>
            <td mat-cell *matCellDef="let element">{{element.redactionCount}}</td>
          </ng-container>
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>
              <mat-icon>delete</mat-icon>
            </th>
            <td mat-cell *matCellDef="let element">
              <mat-icon (click)="$event.stopPropagation(); deleteOrUndoRule(element.id);">delete</mat-icon>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="reportColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: reportColumns;"></tr>
        </table>
      </ng-template>
    </ng-template>
  </ng-template>
</div>
